import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import useU2000AxiosAuthenticated from "../u2000Core/axios/U2000UseAxiosAuthenticated";
import { U2000HandleApiError } from "../u2000Core/axios/U2000HandleApiError";
import { useToast } from "../u2000Core/context/toast/U2000ToastContext";
import type { U2000AutoCompleteSearchResult } from "../u2000Core/types/U2000AutoCompleteSearchResult";
import { u2000ExtractAutoCompleteResults } from "../u2000Core/utils/u2000ExtractAutoCompleteResults";
import { doFindProject, luHandleAppiError, type U3121FindProjectItem } from "../u3121Project/U3121Service";
import { NS } from "../u3121Project/U3121";

/** Recherche projet via POST /U3121/findProject (dialog Ajouter). */
export function useU3139FindProjectHandlers() {
  const axios = useU2000AxiosAuthenticated();
  const { t } = useTranslation();
  const toast = useToast();

  const search = useCallback(
    async (criterias: { fieldName: string; value: unknown }[]): Promise<U2000AutoCompleteSearchResult<U3121FindProjectItem>> => {
      try {
        const response = await doFindProject(axios, criterias);
        return u2000ExtractAutoCompleteResults<U3121FindProjectItem>(response.data);
      } catch (error: unknown) {
        const errorResult = U2000HandleApiError(error as Error, t, NS, luHandleAppiError);
        if (errorResult.genericErrors?.length) {
          errorResult.genericErrors.forEach((err) => toast.error(err.text, err.title));
        }
        return { results: [], totalCount: 0, truncated: false };
      }
    },
    [axios, t, toast],
  );

  return { search };
}
